import React from 'react';
import {
  Box, Button, Container, Stack,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  ErrorBox,
  ErrorTitle,
  ErrorMessage,
  Fab,
} from '@marageti/z4-lib';
import LinkCardPerson from '../../../components/list-item-link-person';
import InviteUserForm from '../../../components/settings-users/invite-user-form';
import { ViewProps } from './types';

const View = ({
  error = undefined,
  inviteOpen,
  isAdmin,
  onCloseInvite,
  onOpenInvite,
  showDisabled,
  teamMembers,
  toggleShowDisabled,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box
      sx={{
        py: { desktop: 4.5, mobile: 6.5 },
        pb: { desktop: 4.5 + 10.5, mobile: 6.5 + 10.5 }, // 10.5 * 8px spacing for 85px fab.
      }}
    >
      {error ? (
        <ErrorBox>
          <ErrorTitle>
            There was an error getting users
          </ErrorTitle>
          <ErrorMessage>
            {`Code: ${error.code}: ${error.message}`}
          </ErrorMessage>
        </ErrorBox>
      ) : (
        <>
          <InviteUserForm open={inviteOpen} onClose={onCloseInvite} />
          <Box
            display="flex"
            justifyContent="flex-end"
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={showDisabled}
                  onChange={toggleShowDisabled}
                />
            )}
              label="Show Disabled"
              sx={{ mb: 3 }}
            />
          </Box>
          <Stack spacing={1} sx={{ mb: { mobile: 4, desktop: 3 }, minHeight: '933px' }}>
            {teamMembers.map((teamMember) => (
              <LinkCardPerson
                individual={teamMember}
                key={teamMember.id}
                to={teamMember.id}
              />
            ))}
          </Stack>
        </>
      )}
    </Box>
    {isAdmin && (
    <Fab
      anchorId="oryx-footer"
    >
      <Button
        variant="contained"
        aria-label="invite user"
        onClick={onOpenInvite}
        role="button"
        sx={{
          minWidth: { mobile: '350px', desktop: 'fit-content' },
        }}
      >
        Invite User
      </Button>
    </Fab>
    )}
  </Container>
);

export default View;
